"use strict";

define('controller/reporting/beta',['require','exports','module','underscore','backbone','../base','../../config','langs','../../view/report.iframe','../../model/report.config'],function (require, exports, module) {
  'use strict';

  var _ = require('underscore');
  var Backbone = require('backbone');
  var RegionController = require('../base');
  var config = require('../../config');
  var langs = require('langs');
  var ReportIframe = require('../../view/report.iframe');
  var ReportConfig = require('../../model/report.config');
  var p = langs.phrase;
  var ReportsBetaController = RegionController.extend({
    header: p('App.Title'),
    authorities: ['PERM_MODIFY_REPORT'],
    features: ['reporting'],
    onStart: function onStart() {
      var self = this,
        app = this.app,
        state = this.state,
        region = this.region,
        reportConfig = new ReportConfig({}),
        models = [reportConfig],
        reportUrl = '',
        page = null;
      reportConfig.fetch().promise().then(function (result) {
        reportUrl = result.data.url;
        state.trigger('page:loaded');
      });
      state.on('page:loaded', function () {
        var token = self.getOneLoginToken();
        page = new ReportIframe({
          host: reportUrl,
          token: token
        });
        region.show(page);
      });
    },
    getOneLoginToken: function getOneLoginToken() {
      var parts = decodeURIComponent(document.cookie).split(';');
      var token = _.find(parts, function (x) {
        return x.includes(config.ACCESS_COOKIE_NAME);
      });
      return token ? token.split('=')[1] : '';
    }
  });
  module.exports = ReportsBetaController;
});

